import { childrenByElementType } from "../../../lib/reactLib"
import { Grid, Stack, Box } from "@mui/material"
import React, { PropsWithChildren } from "react"
import { StandardMainPanel } from "./StandardMainPanel"
import { StandardSidePanel } from "./StandardSidePanel"

function findStandardMainPanel(node: React.ReactNode): React.ReactElement | undefined {
    if (!React.isValidElement(node)) return undefined
    if (node.type === StandardMainPanel) return node

    const children = node.props?.children
    if (Array.isArray(children)) {
        return children.map(findStandardMainPanel).find(Boolean)
    }

    return findStandardMainPanel(children)
}

const sizeMap = {
    full: 12,
    half: 6,
    third: 4,
}

export function StandardForm({ children }: PropsWithChildren) {
    const childGroups = childrenByElementType(children, [])

    return (
        <Grid container spacing="1.5rem" columns={{ xs: 8, md: 12 }}>
            <Grid item xs={8} md={8}>
                {childGroups.has(StandardMainPanel) && (
                    <Grid container spacing="1.5rem">
                        {childGroups.get(StandardMainPanel)?.map((child, index) => {
                            const foundPanel = findStandardMainPanel(child)

                            const colSize = foundPanel?.props.size
                                ? sizeMap[foundPanel.props.size as keyof typeof sizeMap]
                                : 12

                            return (
                                <Grid item xs={colSize} key={index} style={{ display: "flex" }}>
                                    <Box width="100%">{child}</Box>
                                </Grid>
                            )
                        })}
                    </Grid>
                )}
            </Grid>

            <Grid item xs={8} md={4}>
                {childGroups.has(StandardSidePanel) && (
                    <Stack direction="column" spacing="1.5rem">
                        {childGroups.get(StandardSidePanel)?.map((child, index) => (
                            <React.Fragment key={index}>{child}</React.Fragment>
                        ))}
                    </Stack>
                )}
            </Grid>
        </Grid>
    )
}
